__turbopack_context__.v({
  "advantage": "ServiceAdvantageCard-module-scss-module__uwJrnW__advantage",
  "attention": "ServiceAdvantageCard-module-scss-module__uwJrnW__attention",
  "icon": "ServiceAdvantageCard-module-scss-module__uwJrnW__icon",
  "service-advantage-card": "ServiceAdvantageCard-module-scss-module__uwJrnW__service-advantage-card",
});
